<div *ngIf="showNoResults" class="navbar-search-results-column no-search-results">
  {{ 'NO_RESULTS_FOUND' | translate }}
</div>

<div *ngIf="!showNoResults" class="d-flex">

  <!-- Products column -->
  <div class="clerk-search-products" [class.w-100]="!hasSidebar" [class.clerk-search-products-with-sidebar]="hasSidebar">
    <div *ngIf="products.length > 0" class="navbar-search-results-column-title">
      {{ 'PRODUCTS' | translate }}
    </div>

    <a
      *ngFor="let product of products; let odd = odd"
      class="text-left global-search-item clerk-search-item d-block text-decoration-none"
      [ngClass]="{ striped: odd }"
      [routerLink]="product.url"
      (click)="productClickEmitter.emit(product.id); closeResultsEmitter.emit()"
    >
      <div class="row m-0 h-100 align-items-center">
        <div class="col-3 p-0 text-center">
          <img
            *ngIf="product.image; else noImage"
            [src]="product.image"
            [alt]="product.name"
            class="clerk-search-item-img"
          />
          <ng-template #noImage>
            <img src="images/no-image.jpg" alt="NO IMAGE" class="clerk-search-item-img" />
          </ng-template>
        </div>
        <div class="col-9 p-0 pl-2 pr-2 text-truncate">
          <span class="d-block text-truncate">{{ product.name }}</span>
          <small *ngIf="product.price != null" class="clerk-search-item-price">
            {{ product.price | number: '1.2-2' }}
          </small>
        </div>
      </div>
    </a>

    <div *ngIf="totalCount > maxResultShow" class="w-100 show-more-button-container">
      <button class="btn btn-light btn-block btn-sm" (click)="navigateToSearchEmitter.emit()">
        <small>{{ 'GUNG_PRODUCT_LIST_LOAD_MORE' | translate: { limit: maxResultShow, total: totalCount } }}</small>
      </button>
    </div>
  </div>

  <!-- Sidebar: suggestions + categories -->
  <div *ngIf="hasSidebar" class="clerk-search-sidebar">

    <div *ngIf="suggestions.length > 0" class="clerk-search-sidebar-section">
      <div class="navbar-search-results-column-title">{{ 'SEARCH_SUGGESTIONS' | translate }}</div>
      <div
        *ngFor="let suggestion of suggestions"
        class="clerk-search-suggestion"
        (click)="navigateToSuggestionEmitter.emit(suggestion)"
      >
        <i class="fa-light fa-magnifying-glass me-1"></i>{{ suggestion }}
      </div>
    </div>

    <div *ngIf="categories.length > 0" class="clerk-search-sidebar-section">
      <div class="navbar-search-results-column-title">{{ 'CATEGORIES' | translate }}</div>
      <a
        *ngFor="let category of categories"
        class="clerk-search-category d-block text-decoration-none"
        [href]="category.url"
        target="_blank"
        rel="noopener noreferrer"
        (click)="closeResultsEmitter.emit()"
      >
        {{ category.name }}
      </a>
    </div>

  </div>
</div>
